"use strict";

/**
 * Main entry point.
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Utils = exports.Api = void 0;
var Api = require("./src/Api/Api");
exports.Api = Api;
var Utils = require("./src/Utils");
exports.Utils = Utils;
var FloodgateEngine_1 = require("./src/FloodgateEngine");
Object.defineProperty(exports, "FloodgateEngine", {
  enumerable: true,
  get: function () {
    return FloodgateEngine_1.FloodgateEngine;
  }
});